var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabelledStatistic',{attrs:{"top":_vm.$translate('min-deposit'),"middle":_vm.formatCurrency(_vm.value, _vm.locale, _vm.currencyOptions)}})
}
var staticRenderFns = []

export { render, staticRenderFns }